module.exports = __webpack_public_path__ + "img/FPG-3.233ba6ab.jpg";